import { Icon } from '@iconify/react';
import windowsFilled from '@iconify/icons-ant-design/windows-filled';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import { DashboardPayload } from 'src/types/dashboardTypes';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(2, 0),
  color: theme.palette.warning.dark,
  backgroundColor: theme.palette.warning.light
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

export default function AppItemOrders({monthCompleted}:any) {
  return (
    <RootStyle>
      <Typography variant="h3">{monthCompleted}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Monthly Completed
      </Typography>
    </RootStyle>
  );
}
